import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "bridge-config"
  }, [_c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('span', {
    staticClass: "niota-state-config"
  }, [_c('p', {
    staticClass: "card-description my-0"
  }, [_vm.mode !== 'import' ? _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iothub.selectText')))]) : _c('span', [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.states.iothub.selectImportText')))])]), _c(VRow, {
    attrs: {
      "align": "center"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c(VAutocomplete, {
    ref: "niotaDevice",
    attrs: {
      "items": _vm.niotaDevices,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "loading": _vm.loadingDevices,
      "search-input": _vm.niotaDeviceSearch,
      "placeholder": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.devicePlaceholder'),
      "hide-selected": _vm.loadingDevices || !_vm.niotaDeviceSearch || _vm.niotaDeviceSearch.length < 2,
      "hide-no-data": _vm.loadingDevices || !_vm.niotaDeviceSearch || _vm.niotaDeviceSearch.length < 2,
      "no-data-text": _vm.$i18n_t('DigitalTwin.DigitalTwin.states.niota.deviceNoResults'),
      "label": `${_vm.$i18n_t('Common.drawer.iotDataHub')} ${_vm.$i18n_t('NiotaClassic.Devices.form.device')}`,
      "rules": _vm.requiredRule,
      "item-value": "id",
      "item-text": "title",
      "autocomplete": "off",
      "return-object": "",
      "no-filter": "",
      "hide-details": ""
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.niotaDeviceSearch = $event;
      },
      "update:search-input": function ($event) {
        _vm.niotaDeviceSearch = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.title)
          }
        }), _c(VListItemSubtitle, {
          domProps: {
            "innerHTML": _vm._s(data.item.eui)
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selectedNiotaDevice,
      callback: function ($$v) {
        _vm.selectedNiotaDevice = $$v;
      },
      expression: "selectedNiotaDevice"
    }
  })], 1), _vm.selectedNiotaDevice && _vm.selectedNiotaDevice.id ? _c(VCol, {
    attrs: {
      "cols": "12",
      "sm": "6"
    }
  }, [_c('a', {
    attrs: {
      "href": `/#/niota-classic/devices/${_vm.selectedNiotaDevice.id}/details`,
      "target": "_blank"
    }
  }, [_vm._v("\n              » " + _vm._s(_vm.selectedNiotaDevice.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.selectedNiotaDevice.id) + ")\n            ")])]) : _vm._e(), _c(VCol, {
    staticClass: "py-0",
    attrs: {
      "cols": "12"
    }
  }, [_vm.selectedNiotaDevice && _vm.niotaDeviceVariables ? _c(VDataTable, {
    attrs: {
      "headers": _vm.niotaDeviceVariableHeaders,
      "footer-props": _vm.niotaDeviceVariableFooterProps,
      "items": _vm.niotaDeviceVariables,
      "single-select": _vm.mode !== 'import',
      "item-key": "variable",
      "show-select": ""
    },
    scopedSlots: _vm._u([{
      key: "item.milliseconds_ago",
      fn: function ({
        item
      }) {
        return [_vm._v("\n                " + _vm._s(item.time_ago) + "\n              ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n                ")])];
      },
      proxy: true
    }], null, false, 544307047),
    model: {
      value: _vm.selectedNiotaDeviceVariable,
      callback: function ($$v) {
        _vm.selectedNiotaDeviceVariable = $$v;
      },
      expression: "selectedNiotaDeviceVariable"
    }
  }) : _vm._e()], 1)], 1)], 1)])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };